import React from 'react';
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"; // Assuming shadcn/ui tabs
import { useTranslation } from 'react-i18next';

interface FloorTabsProps {
  availableFloors: number[]; // e.g., [1, 2, 3]
  selectedFloor: number;
  onFloorChange: (floor: number) => void;
  className?: string;
}

const FloorTabs: React.FC<FloorTabsProps> = ({
  availableFloors,
  selectedFloor,
  onFloorChange,
  className = '',
}) => {
  const { t } = useTranslation();

  // Sort floors just in case they aren't sequential
  const sortedFloors = [...availableFloors].sort((a, b) => a - b);

  const handleValueChange = (value: string) => {
    onFloorChange(parseInt(value, 10));
  };

  return (
    <Tabs
      value={selectedFloor.toString()}
      onValueChange={handleValueChange}
      className={`w-full max-w-md mx-auto ${className}`} // Center tabs and limit width
    >
      {/* Apply standard shadcn/ui TabsList styling */}
      <TabsList className={`grid w-full grid-cols-${sortedFloors.length} h-10`}> {/* Dynamic grid cols */}
        {sortedFloors.map((floor) => (
          // Apply standard shadcn/ui TabsTrigger styling
          <TabsTrigger key={floor} value={floor.toString()} className="text-sm data-[state=active]:shadow-sm">
            {t('map.floorLabel', 'Floor {{floor}}', { floor })}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default FloorTabs;
